import Vue from 'vue';
import Vuex from 'vuex';

import Dealers from '../../used-vue/store/modules/dealers';
import CustomerData from '../../used-vue/store/modules/customer-data';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        model: [],
        fuelChoice: '',
        transmissionChoice: '',
        notes: '',
        dealer: [],
        customerAddress: '',
        date: '',
        time: '',
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        contactMethod: '',
        onlyElectric: 0,
        step1Page: false,
        step2Page: false,
        step2aPage: false,
        step3Page: false,
        step4Page: false,
        step5Page: false,
        thankYouPage: false,
        electricOrHybridSelected: true,
        directionsLink: null,
    },
    mutations: {
        setModel(state, newModel) {
            newModel.model_title = newModel.model_title.replace('Citroen', 'Citroën');
            state.model = newModel;
        },
        setFuelChoice(state, payload) {
            state.fuelChoice = payload.fuelChoice;
            const lowercaseFuelChoice = payload.fuelChoice.toLowerCase();
            if (lowercaseFuelChoice.indexOf('electric') >= 0 || lowercaseFuelChoice.indexOf('hybrid') >= 0) {
                state.electricOrHybridSelected = true;
            } else {
                state.electricOrHybridSelected = false;
            }
        },
        setElectricOrHybridSelected(state, value) {
            state.electricOrHybridSelected = value;
        },
        setTransmissionChoice(state, payload) {
            state.transmissionChoice = payload.transmissionChoice;
        },
        setNotes(state, payload) {
            state.notes = payload.notes;
        },
        setDealer(state, payload) {
            state.dealer = payload.dealer;
        },
        setCustomerAddress(state, payload) {
            state.customerAddress = payload.customerAddress;
        },
        setDate(state, payload) {
            state.date = payload.date;
        },
        setTime(state, payload) {
            state.time = payload.time;
        },
        setTitle(state, title) {
            state.title = title;
        },
        setFirstName(state, firstName) {
            state.firstName = firstName;
        },
        setLastName(state, lastName) {
            state.lastName = lastName;
        },
        setEmail(state, email) {
            state.email = email;
        },
        setPhone(state, phone) {
            state.phone = phone;
        },
        setContactMethod(state, contactMethod) {
            state.contactMethod = contactMethod;
        },
        setOnlyElectric(state, onlyElectric) {
            state.onlyElectric = onlyElectric;
        },
        setStep1Page(state, val) {
            state.step1Page = val;
        },
        setStep2Page(state, val) {
            state.step2Page = val;
        },
        setStep2aPage(state, val) {
            state.step2aPage = val;
        },
        setStep3Page(state, val) {
            state.step3Page = val;
        },
        setStep4Page(state, val) {
            state.step4Page = val;
        },
        setStep5Page(state, val) {
            state.step5Page = val;
        },
        setThankYouPage(state, val) {
            state.thankYouPage = val;
        },
        setDealerDirectionsLink(state, directionsLink) {
            state.directionsLink = directionsLink;
        }
    },
    actions: { },
    modules: {
        CustomerData,
        Dealers
    }
});

export default store;


// WEBPACK FOOTER //
// ./resources/assets/js/test-drive/store/index.js